module.exports = __webpack_public_path__ + "static/media/src-template.be5fee1c.png";